export class ActivityBasedFormFlow {
    constructor(formFlowDefinition, inputParameters) {
        this.formFlowDefinition = formFlowDefinition;
        if (!formFlowDefinition.Activities) {
            throw new Error(`[Form Flow Engine] Activities are not configured for form flow "${formFlowDefinition.PK}"`);
        }
        this.variables = new Map();
        this.activities = formFlowDefinition.Activities.reduce((map, a) => map.set(a.Id, a), new Map());
        if (inputParameters) {
            for (const [name, value] of Object.entries(inputParameters)) {
                this.setVariableValue(name, value);
            }
        }
    }
    setVariableValue(name, value) {
        this.variables.set(name, value);
    }
    getVariableValue(name) {
        return this.variables.get(name);
    }
    findStartActivityId() {
        const activities = this.formFlowDefinition.Activities;
        const nextActivities = activities.reduce((reduced, activity) => {
            if (activity.NextActivityId) {
                reduced.add(activity.NextActivityId);
            }
            return reduced;
        }, new Set());
        const startActivities = activities.filter((a) => !nextActivities.has(a.Id));
        if (startActivities.length !== 1) {
            throw new Error(`[Form Flow Engine] Expected single start activity for form flow "${this.formFlowDefinition.PK}"`);
        }
        return startActivities[0].Id;
    }
    invokeActivity(activityId) {
        const activity = this.activities.get(activityId);
        if (!activity) {
            throw new Error(`[Form Flow Engine] Activity id "${activityId}" is not defined for form flow "${this.formFlowDefinition.PK}".`);
        }
        return this.invokeActivityCore(activity);
    }
    onComplete() { }
}
